import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DefaultButton } from './styles';

export default class Button extends Component {
  render() {
    const { text, disabled, ...props } = this.props;
    return (
      <DefaultButton disabled={disabled} {...props}>
        {text}
      </DefaultButton>
    );
  }
}

Button.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  disabled: PropTypes.bool
};

Button.defaultProps = {
  disabled: false
};
